module.exports = function getResource(label, vars = []) {
    let resources = {
        similarProductsTitle: 'Similar Products'
    };
    return resources[label];
};
